// List
export const List = {
  baseStyle: {
    borderWidth: 1,
    borderColor: 'gray.300',
    borderRadius: 'lg',
  },
};

// ListItem
export const ListItem = {
  baseStyle: {
    borderTopWidth: 1,
    borderColor: 'gray.300',
  },
  defaultProps: {
    start: 1,
  },
};

// ListIcon
export const ListIcon = {};
